<section class="pt-2">
  <div class="container-style">
    <div class="row align-items-center mx-0 p-1">
      <div class="col-lg-6 col-md-12 col-sm-12 col-12">
        <h6>{{isFormView ? 'Registrar detalle de pedido' : 'Detalle de pedido'}}</h6>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex justify-content-end gap-2">
        @if (!swMandatoryQuotation) {
        <app-custom-button [title]="'Importar Detalles'" [icon]="'pi pi-file-import'" [severity]="'primary'"
          [disabled]="disablePartial" (onClick)="openOrderDetailImportModal()">
        </app-custom-button>
        }
        <app-custom-modal #orderDetailImportModal [label]="'Importar Detalles'" [width]="'40rem'"
          [header]="'Importar Detalles'" [children]="componentOrderDetailImportModal"
          [inputs$]="inputsForOrderDetailImportModals$" (params)="reload($event.reload)" hidden>
        </app-custom-modal>
        <app-custom-button [title]="'Cambiar Fecha Compromiso'" [icon]="'pi pi-calendar-clock'" [severity]="'warn'"
          [disabled]="disablePartial" (onClick)="openCompromiseDateModal()">
        </app-custom-button>
        <app-custom-modal #compromiseDate [label]="'Cambiar Fecha Compromiso'" [header]="'Cambiar Fecha Compromiso'"
          [children]="componentUpdateCompromiseDateModal" [inputs$]="inputsForcompromiseDateModals$" [width]="'25rem'"
          (params)="reload($event.reload)" hidden>
        </app-custom-modal>
        @if (swQuotation) {
        <app-custom-button [disabled]="disableOrderFromQuotation" [title]="'Artículos Cotizados'"
          [label]="'Artículos Cotizados'" [severity]="'success'" [width]="'8'"
          (onClick)="openOrderFromQuotationModal()">
        </app-custom-button>
        }
        <app-custom-modal #orderFromQuotation [label]="'Artículos Cotizados'" [header]="'Artículos Cotizados'"
          [inputs$]="inputsForOrderFromQuotationModals$" [children]="componentOrderFromQuotationStepper" hidden
          (params)="reloadHeaderAndDetail($event)">
        </app-custom-modal>
        @if (!swMandatoryQuotation) {
        <app-custom-button [disabled]="disablePartial"
          [label]="swQuotation ? 'Artículos sin Cotizaciones' : 'Nuevo Detalle'" [severity]="'success'"
          [width]="swQuotation ? '6.5' : '8'" (onClick)="openArticleSelectionModal()">
        </app-custom-button>
        }
        <app-custom-modal #articleForOrderSelection [inputs$]="inputsForArticlesSelection$"
          [children]="componentTableSelection" [output$]="output$" [label]="'Seleccionar'"
          [header]="'Selección de Artículos'" hidden (selectedItems)="handleSelectedItem($event)">
        </app-custom-modal>
      </div>
    </div>
    <div class="row mx-0" [hidden]="!isFormView">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
        <app-register-order-detail [orderDetails]="orderDetails" [orderContract]="orderModel"
          [costCenterPriceContract]="costCenterPriceContract" [orderDetailContract]="orderDetail"
          [swReservation]="swReservation" [isCreatingOrderFromQuotation]="isCreatingOrderFromQuotation"
          (updateListDetail)="getOrderDetailsForCaptureTable()" (isFormView)="getFormView($event)"
          (costCenterPriceRegister)="getCostCenterPriceOpen($event)"
          (openOrderPriceModal)="handleCostCenterPriceModal($event)">
        </app-register-order-detail>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <app-custom-table [showRecover]="true" [headers]="detailHeader" [data]="detailData"
        [checkBoxAction]="checkboxActions" [clearSelectionTrigger]="clearSelectionTrigger" [actions]="tableActions"
        [showCheckbox]="!disablePartial" (onAction)="onAction($event)"
        (onRecoverData)="getOrderDetailsForCaptureTable()" (onPageChange)="onPageChange($event)">
      </app-custom-table>
    </div>
  </div>
</section>
<!-- Precios Pedido -->
<app-custom-modal #orderPriceModal [inputs$]="inputsForPriceOrderModals$" hidden [header]="'Precios por pedido'"
  [width]="'50rem'" [label]="'Precios por pedido'" [children]="componentOrderPriceModal" (params)="reload($event)">
</app-custom-modal>
<!-- Precios C.Costos -->
<app-custom-modal #costCenterPriceRegisterModal [label]="'Precios C.Costos - Captura'"
  [header]="'Precios C.Costos - Captura'" [inputs$]="inputsForRegisterModals$" [width]="'50rem'"
  [children]="componentRegisterModal" hidden (params)="getCostCenterPriceRegister($event.costCenterPriceModel)">
</app-custom-modal>